/** Ads (A05/A06 epics): connected ad accounts performance via /v1/connectors/performance. */
import { useApp } from '../../../lib/app-context';
import { useFormat } from '../../../lib/format';
import { ListScreen, str } from '../_shared/ListScreen';

export function AdsPage() {
  const { t } = useApp();
  const f = useFormat();
  return (
    <ListScreen titleKey="shell.screens.ads.title" introKey="shell.screens.ads.intro" path="/v1/connectors/performance" emptyKey="shell.screens.ads.empty" emptyAction={{ to: '/integrations', labelKey: 'shell.empty.connect' }}
      columns={[
        { key: 'platform', header: t('shell.col.platform'), render: (r) => str(r.platform ?? r.provider) },
        { key: 'campaign', header: t('shell.col.campaign'), render: (r) => <bdi>{f.text(r.campaign ?? r.name)}</bdi> },
        { key: 'spend', header: t('shell.col.spend'), numeric: true, render: (r) => f.money(Number(r.spendMinor ?? r.spend_minor ?? 0), str(r.currency) || undefined) },
        { key: 'leads', header: t('shell.col.leads'), numeric: true, render: (r) => f.number(Number(r.leads ?? 0)) },
      ]} />
  );
}
